class Search {
    constructor() {
        $('.search > form > .searchIcon').on('click', function () {
            $(this).closest('form').submit();
        });
    }
}

$(document).ready(function () {
    new Search();
});